$(function(){

    /*Declare Sweetalert2 minx */
    const Toast = swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 2000,
        onOpen: (toast) => {
            toast.addEventListener('mouseenter', swal.stopTimer)
            toast.addEventListener('mouseleave', swal.resumeTimer)
        }
    })
    function convertDate(date){
        var year = date[0]+date[1]+date[2]+date[3];
        var month = date[4]+date[5];
        var day = date[6]+date[7];
        var result = day+'/'+month+'/'+year;
        return result;
    }
    /*Australia National Public holidays for 2020*/
/*
    $.get("https://data.gov.au/data/api/3/action/datastore_search_sql?sql=SELECT * from \"c4163dc4-4f5a-4cae-b787-43ef0fcf8d8b\"", function(data, status){
        let govData = data['result']['records'];
        var nationHolidays = [];
        let national = ['New Year\'s Day', 'Australia Day', 'Good Friday', 'Saturday before Easter Sunday', 'Easter Sunday','Easter Monday', 'Anzac Day', 'Queen\'s Birthday', 'Christmas Day', 'Boxing Day', 'Boxing Day (Additional day)'];
        for(var key in govData){
            if (govData[key]['Jurisdiction'] == 'vic' && national.includes(govData[key]['Holiday Name'])) {
                var converter = convertDate(govData[key]['Date']);
                nationHolidays.push(converter);
            }
        }
        /!*Datepicker Disable Holidays*!/
        function DisableDates(date) {
            var string = jQuery.datepicker.formatDate('dd/mm/yy', date);
            return [nationHolidays.indexOf(string) == -1];
        }
        function noWeekendsOrHolidays(date) {
            var noWeekend = $.datepicker.noWeekends(date);
            if (noWeekend[0]) {
                return DisableDates(date);
            } else {
                return noWeekend;
            }
        }

        const payDate = {
            changeMonth: true,
            // changeYear: true,
            showOtherMonths: true,
            selectOtherMonths: true,
            dateFormat:'dd/mm/yy',
            maxDate: "+60d",
            // yearRange:'c-1:c+1',
            beforeShowDay: noWeekendsOrHolidays,
        };
        $("#primary_next_pay_date").datepicker(payDate);
        $("#next_pay_date").datepicker(payDate);
    });
*/

    // Hardcoded 2025 Victoria Public Holidays (in dd/mm/yy format)
    const nationHolidays = [
        "01/01/25", // New Year's Day
        "27/01/25", // Australia Day (observed on Monday)
        "10/03/25", // Labour Day
        "18/04/25", // Good Friday
        "19/04/25", // Saturday before Easter Sunday
        "21/04/25", // Easter Monday
        "25/04/25", // Anzac Day
        "09/06/25", // King's Birthday (previously Queen's)
        "26/09/25", // Friday before AFL Grand Final
        "04/11/25", // Melbourne Cup (VIC specific)
        "25/12/25", // Christmas Day
        "26/12/25"  // Boxing Day
    ];

    /* Datepicker Disable Functions */
    function DisableDates(date) {
        const dateString = $.datepicker.formatDate('dd/mm/yy', date);
        return [nationHolidays.indexOf(dateString) === -1];
    }

    function noWeekendsOrHolidays(date) {
        const noWeekend = $.datepicker.noWeekends(date);
        return noWeekend[0] ? DisableDates(date) : noWeekend;
    }

    /* Initialize Datepickers */
    const payDateOptions = {
        changeMonth: true,
        showOtherMonths: true,
        selectOtherMonths: true,
        dateFormat: 'dd/mm/yy',
        maxDate: "+60d",
        beforeShowDay: noWeekendsOrHolidays
    };

    $("#primary_next_pay_date").datepicker(payDateOptions);
    $("#next_pay_date").datepicker(payDateOptions);

    /*Datepicker format*/
    const generalDate =  {
        changeMonth: true,
        changeYear: true,
        showOtherMonths: true,
        selectOtherMonths: true,
        dateFormat:'dd/mm/yy',
        yearRange:'c-100:c+20',
    }
    /*Validation of application form input*/
    /*==========================================================================Validation Start=======================================================*/


    $('input,textarea,select').filter('[required]').blur(function() {
        var value = $( this ).val();
        if(value != "") {
            $(this).css('border-color', 'green')
        }
    });



    $( "#first_name" ).blur(function() {
        var first_name= $( "#first_name" ).val();
        if(first_name != "" && !/^[a-zA-Z]*$/g.test(first_name)){
            swal.fire({
                icon: 'warning',
                title: 'First Name Input Invalid',
            })
            this.style.borderColor = "red";
        } else if($(this).val() != "") {
            $(this).css('border-color', 'green')
        }

    });


    $( "#last_name" ).blur(function() {
        var last_name= $( "#last_name" ).val();
        if(last_name != "" && !/^[a-zA-Z]*$/g.test(last_name)){
            swal.fire({
                icon: 'warning',
                title: 'Last Name Input Invalid',
            })
            this.style.borderColor = "red";
        } else if($(this).val() != "") {
            $(this).css('border-color', 'green')
        }

    });

    $( "#middle_name" ).blur(function() {
        var last_name= $( "#middle_name" ).val();
        if(last_name != "" && !/^[a-zA-Z]*$/g.test(last_name)){
            swal.fire({
                icon: 'warning',
                title: 'Middle Name Input Invalid',
            })
            this.style.borderColor = "red";
        } else if($(this).val() != "") {
            $(this).css('border-color', 'green')
        }

    });
    $("#dob").datepicker(generalDate);
    $( "#dob" ).change(function() {
        //change the input value into date format
        let dob = new Date($("#dob").datepicker("getDate"));
        let end = new Date();
        let diff = new Date(end - dob);
        let years = diff / 1000 / 60 / 60 / 24 / 365;
        if(dob !=='' && dob !='Invalid Date' && years < 18)
        {
            swal.fire({
                icon: 'warning',
                title: 'You must be 18 years old to apply for a loan!',
            })
            this.style.borderColor = "red";
            $("#dob").val("");
        } else if($(this).val() != "") {
            $(this).css('border-color', 'green')
        }

    });


    $( "#mobile" ).blur(function() {
        var mobile= $( "#mobile" ).val();
        if(mobile != "" && !/^\d{10}$/g.test(mobile)){
            swal.fire({
                icon: 'warning',
                title: 'Mobile Phone Input Invalid',
            })
            $(".phoneone").css('border-color', 'red');
        } else if($(this).val() != "") {
            $(".phoneone").css('border-color', 'green')
        }
    });

    var verifyresult = 0;
    $( "#veri_code" ).blur(function() {
        var veri_code= $( "#veri_code" ).val();
        if(veri_code != "" && !/^\d{4}$/g.test(veri_code)){
            swal.fire({
                icon: 'warning',
                title: 'Verification Code Input Invalid',
            })
            this.style.borderColor = "red";
        } else if($(this).val() != "") {
            /*confirmationResult.confirm(veri_code).then(function (result) {
                $( "#veri_code" ).css('border-color', 'green');
                verifyresult = 1;
                $("#veri_code").prop('readonly', true);
                $("#mobile").prop('readonly', true);
            }).catch(function (error) {
                verifyresult = 0;
                swal.fire({
                    icon: 'warning',
                    title: 'Verify code not matched',
                })
                $( "#veri_code" ).css('border-color', 'red');
            });*/

        }
    });


    $( "#email" ).blur(function() {
        var email= $( "#email" ).val();

        if(email != "" && !/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)){

            swal.fire({
                icon: 'warning',
                title: 'Email Input Invalid',
            })
            this.style.borderColor = "red";
        } else if($(this).val() != "") {
            $(this).css('border-color', 'green')
        }
    });




    $( "#ddl_share_partner" ).blur(function() {
        var ddl_share_partner= $("#ddl_share_partner").val();
        if(ddl_share_partner =='' && $("#marital_status").val() !=="Single")
        {
            swal.fire({
                icon: 'warning',
                title: 'Share Expense Can Not Be Blank',
            })
            this.style.borderColor = "red";
        } else if($(this).val() != "") {
            $(this).css('border-color', 'green')
        }
    });

    $( "#partner_income" ).blur(function() {
        let partner_income= $( "#partner_income" ).val();
        if($("#ddl_share_partner").val() == 1)
        {
            if(partner_income != "" && !/^\d+$/g.test(partner_income)){
                swal.fire({
                    icon: 'warning',
                    title: 'Partner Monthly Income Invalid',
                })
                this.style.borderColor = "red";

            } else if($(this).val() != "") {
                $(this).css('border-color', 'green')
            }
        }
    });

    $( "#em_contact_name" ).blur(function() {
        var em_contact_name= $( "#em_contact_name" ).val();
        if(em_contact_name != "" && !/^[a-zA-Z]+(([',. -][a-zA-Z ])?[a-zA-Z]*)*$/g.test(em_contact_name)){
            swal.fire({
                icon: 'warning',
                title: 'Emergency Contact Name Input Invalid',
            })
            this.style.borderColor = "red";
        } else if($(this).val() != "") {
            $(this).css('border-color', 'green')
        }
    });


    $( "#em_contact_no" ).blur(function() {
        var em_contact_no= $( "#em_contact_no" ).val();
        if(em_contact_no != "" && !/^\d+$/g.test(em_contact_no)){
            swal.fire({
                icon: 'warning',
                title: 'Contact Person Number Input Invalid',
            })
            this.style.borderColor = "red";
        } else if($(this).val() != "") {
            $(this).css('border-color', 'green')
        }
    });

    $('#id_details').change(function () {
        $( "#license_state" ).val('');
        $( "#license_no" ).val('');
        $( "#license_state" ).val('');
        $( "#license_expiry" ).val('');
        $( "#card_no" ).val('');
        $( "#place_of_issue" ).val('');
        $( "#passport_no" ).val('');
        $( "#issue_country" ).val('');
    });



    $("#license_expiry").datepicker(generalDate);
    $("#license_expiry").change(function () {
        let day= new Date($("#license_expiry").datepicker("getDate"));
        let end   = new Date();
        let diff  = new Date(end - day);
        if(diff<0){
            Toast.fire({
                icon: 'success',
            })
            this.style.borderColor = "green";
        }else{
            $("#license_expiry").val("");
            swal.fire({
                icon: 'warning',
                title: "Please enter valid information!",
            });
        }

    });



    $( "#autocomplete" ).blur(function() {
        var autocomplete= $("#autocomplete").val();
        if(autocomplete =='')
        {
            swal.fire({
                icon: 'warning',
                title: 'Residential Address Can Not Be Blank',
            })
            this.style.borderColor = "red";
        } else if($(this).val() != "") {
            $(this).css('border-color', 'green')
        }
    });



    $( "#route" ).blur(function() {
        var route= $( "#route" ).val();
        if(route != "" && !/^[a-zA-Z]+(([',. -][a-zA-Z ])?[a-zA-Z]*)*$/g.test(route)){
            swal.fire({
                icon: 'warning',
                title: 'Street Name Input Invalid',
            })
            this.style.borderColor = "red";
        } else if($(this).val() != "") {
            $(this).css('border-color', 'green')
        }
    });

    $( "#locality" ).blur(function() {
        var locality= $( "#locality" ).val();
        if(locality != "" && !/^[a-zA-Z]+(([',. -][a-zA-Z ])?[a-zA-Z]*)*$/g.test(locality)){
            swal.fire({
                icon: 'warning',
                title: 'Suburb Input Invalid',
            })
            this.style.borderColor = "red";
        } else if($(this).val() != "") {
            $(this).css('border-color', 'green')
        }
    });

    $( "#administrative_area_level_1" ).blur(function() {
        var administrative_area_level_1= $( "#administrative_area_level_1" ).val();
        if(administrative_area_level_1 != "" && !/^[a-zA-Z]+(([',. -][a-zA-Z ])?[a-zA-Z]*)*$/g.test(administrative_area_level_1)){
            swal.fire({
                icon: 'warning',
                title: 'State Input Invalid',
            })
            this.style.borderColor = "red";
        } else if($(this).val() != "") {
            $(this).css('border-color', 'green')
        }
    });


    $( "#postal_code" ).blur(function() {
        var postal_code= $( "#postal_code" ).val();
        if(!/^\d+$/g.test(postal_code)){
            swal.fire({
                icon: 'warning',
                title: 'Postal Code Input Invalid',
            })
            this.style.borderColor = "red";
        } else if($(this).val() != "") {
            $(this).css('border-color', 'green')
        }
    });




    $( "#emp_status" ).change(function() {
        if($( "#emp_status" ).val() !== 'unemployed-government benefits'){
            $("#next").prop('disabled', false);
        }
        if($( "#emp_status" ).val() === 'unemployed-government benefits' || $( "#emp_status" ).val() === ''){
            $("#employ_start_date").val("");
            $("#occupation").val("");
            $("#company_name").val("");
            $("#company_addr").val("");
            $("#company_phone").val("");
            $("#primary_next_pay_date").val("");
            $("#primary_income_freq").val("");
        }
    });



    $("#primary_next_pay_date").change(function () {
        let payday= new Date( $("#primary_next_pay_date").datepicker("getDate"));
        let end   = new Date();
        let diff  = new Date(end - payday);

        if($("#emp_status").val() !== "unemployed-government benefits" && $("#emp_status").val() !== '') {
            if(diff>0){
                $("#primary_next_pay_date").val("");
                swal.fire({
                    icon: 'warning',
                    title: 'Next Pay Date Input Invalid',
                })
                this.style.borderColor = "red";
            }
        } else if($(this).val() != "") {
            $(this).css('border-color', 'green')
        }

    })


    $( "#another_job" ).change(function() {
        if($( "#another_job" ).val() == 0){
            $("#second_emp_status").val("");
            $("#next_pay_date").val("");
            $("#another_company_name").val("");
            $("#another_company_addr").val("");
            $("#another_company_phone").val("");
            $("#second_occupation").val("");
            $("#income_freq").val("");
            $("#length_of_employment").val("");
            $("#another_job_income").val("");
        }
    });


    $("#next_pay_date").change(function () {
        let payday= new Date( $("#next_pay_date").datepicker("getDate"));
        let end   = new Date();
        let diff  = new Date(end - payday);

        if($("#another_job").val() === '1') {
            if(diff>0){
                $("#next_pay_date").val("");
                swal.fire({
                    icon: 'warning',
                    title: 'Next Pay Date Input Invalid',
                })
                this.style.borderColor = "red";
            } else if($(this).val() != "") {
                $(this).css('border-color', 'green')
            }
        }
    });



    $( "#another_company_phone" ).blur(function() {
        let another_company_phone= $( "#another_company_phone" ).val();
        if($("#another_job").val()==='1')
        {
            if(another_company_phone != "" && !/^\d+$/g.test(another_company_phone)){
                swal.fire({
                    icon: 'warning',
                    title: 'Other Company Phone Input Invalid',
                })
                this.style.borderColor = "red";
            } else if($(this).val() != "") {
                $(this).css('border-color', 'green')
            }
        }
    });


    /*====================================================================================Validation End=======================================================*/

    $("#marital_status").change(function(){
        if($("#marital_status").val()=="Married"||$("#marital_status").val()=="Defacto"||$("#marital_status").val()=="Partner"){

            $("#share_partner").css("display","block");
            $("#share_partner :input").attr("required","required")
            $("#share_partner >select").attr("required","required")
        }
        else {
            $("#share_partner").css("display","none");
            $("#share_partner :input").removeAttr("required");
            $("#share_partner >select").removeAttr("required");
        }

    });

    $("#owned_a_motor").change(function() {
        if($("#owned_a_motor").val() == 1) {
            $("#add_a_security").css("display","block");
            $("#add_a_security :input").attr("required","required")
            $("#add_a_security >select").attr("required","required")
        } else {
            $("#add_a_security").css("display","none");
            $("#add_a_security :input").removeAttr("required");
            $("#add_a_security >select").removeAttr("required");
        }
    });

    $("#add_a_security :input").change(function() {
          if($(this).val() == 1) {
              $("#car_rego").css("display","block");
          } else {
              $("#car_rego").css("display","none");
          }
    });

    $("#ddl_share_partner").change(function() {

        if($("#ddl_share_partner").val()==1){
            $("#partner_income_details").css("display","block")
            $("#partner_income_details :input").attr("required","required")
            $("#partner_income_details >select").attr("required","required")
        }
        else {
            $("#partner_income_details").css("display","none")
            $("#partner_income_details :input").removeAttr("required");
            $("#partner_income_details >select").removeAttr("required");
        }

    });

    $("#residential_status").change(function(){
        $("#residential_status_details").css("display","none");
        $("#residential_status_details :input").removeAttr("required");
        $("#residential_status_details >select").removeAttr("required");
        $("#mortgage_status_detail").css("display","none");
        $("#mortgage_detail :input").removeAttr("required");
        $("#mortgage_detail >select").removeAttr("required");

        if($("#residential_status").val()=="rent"){
            $("#residential_status_details").css("display","block")
            $("#residential_status_details :input").attr("required","required")
            $("#residential_status_details >select").attr("required","required")
        }
        else if($("#residential_status").val()=="mortgage"){
            $("#mortgage_status_detail").css("display","block");
            $("#mortgage_detail :input").attr("required","required")
            $("#mortgage_detail >select").attr("required","required")
        }
    });


    $("#id_details").change(function(){
        $("#driving_license_details").css("display","none");
        $("#driving_license_details :input").removeAttr("required");
        $("#driving_license_details >select").removeAttr("required");
        $("#proof_of_age_details").css("display","none");
        $("#proof_of_age_details :input").removeAttr("required");
        $("#proof_of_age_details >select").removeAttr("required");
        $("#passport_details").css("display","none");
        $("#passport_details :input").removeAttr("required");
        $("#passport_details >select").removeAttr("required");
        if($("#id_details").val()=="Driver licence"){
            $("#driving_license_details").css("display","block")
            $("#driving_license_details :input").attr("required","required")
            $("#driving_license_details >select").attr("required","required")
        }
        else if($("#id_details").val()=="proof of age card"){
            $("#proof_of_age_details").css("display","block")
            $("#proof_of_age_details :input").attr("required","required")
            $("#proof_of_age_details >select").attr("required","required")

        }
        else if ($("#id_details").val()=="passport") {
            $("#passport_details").css("display","block")
            $("#passport_details :input").attr("required","required")
            $("#passport_details >select").attr("required","required")
        }
    });

    $("#driving_license_details :input").blur(function (e) {
        var value = $( this ).val();
        if(value != "" || value != null ) {
            $(this).css('border-color', 'green')
        }
    });

    $("#driving_license_details >select").blur(function (e) {
        var value = $( this ).val();
        if(value != "" || value != null ) {
            $(this).css('border-color', 'green')
        }
    });

    $("#proof_of_age_details :input").blur(function (e) {
        var value = $( this ).val();
        if(value != "" || value != null ) {
            $(this).css('border-color', 'green')
        }
    });
    $("#proof_of_age_details >select").blur(function (e) {
        var value = $( this ).val();
        if(value != "" || value != null ) {
            $(this).css('border-color', 'green')
        }
    });

    $("#passport_details :input").blur(function (e) {
        var value = $( this ).val();
        if(value != "" || value != null ) {
            $(this).css('border-color', 'green')
        }
    });

    $("#passport_details >select").blur(function (e) {
        var value = $( this ).val();
        if(value != "" || value != null ) {
            $(this).css('border-color', 'green')
        }
    });

    $("#emp_status").change(function(){
        $("#employment_status_details").css("display","none")
        $("#employment_status_details :input").removeAttr("required");
        $("#employment_status_details >select").removeAttr("required");
        $("#unemp").css("display","none")
        $("#unemp :input").removeAttr("required");
        $("#unemp >select").removeAttr("required");
        if($("#emp_status").val()!="unemployed-government benefits"){
            $("#employment_status_details").css("display","block")
            $("#employment_status_details :input").attr("required","required")
            $("#employment_status_details >select").attr("required","required")
        }
        else{
            $("#unemp").css("display","block")
            $("#unemp :input").attr("required","required")
            $("#unemp >select").attr("required","required")
        }
    });

    $("#employment_status_details :input").blur(function (e) {
        var value = $( this ).val();
        if(value != "" || value != null ) {
            $(this).css('border-color', 'green')
        }
    });

    $("#employment_status_details >select").blur(function (e) {
        var value = $( this ).val();
        if(value != "" || value != null ) {
            $(this).css('border-color', 'green')
        }
    });

    $("#another_job").change(function(){
        if($("#another_job").val()!=0){
            $("#other_company_details").css("display","block")
            $("#other_company_details :input").attr("required","required")
            $("#other_company_details >select").attr("required","required")
        }
        else{
            $("#other_company_details").css("display","none")
            $("#other_company_details :input").removeAttr("required");
            $("#other_company_details >select").removeAttr("required");
        }
    });

    $("#other_company_details :input").blur(function (e) {
        var value = $( this ).val();
        if(value != "" || value != null ) {
            $(this).css('border-color', 'green')
        }
    });

    $("#other_company_details >select").blur(function (e) {
        var value = $( this ).val();
        if(value != "" || value != null ) {
            $(this).css('border-color', 'green')
        }
    });

    $("#agent_name").blur(function (e) {
        var value = $( this ).val();
        if(value != "" || value != null ) {
            $(this).css('border-color', 'green')
        }
    });

    $("#agent_mobile").blur(function (e) {
        var value = $( this ).val();
        if(value != "" || value != null ) {
            $(this).css('border-color', 'green')
        }
    });

    $("#mortgage_detail").blur(function (e) {
        var value = $( this ).val();
        if(value != "" || value != null ) {
            $(this).css('border-color', 'green')
        }
    });



   /* $("#loan_amount").blur(function(){
        if($("#loan_amount").val()%100!=0||$("#loan_amount").val()>2000){
            alert("Invalid Input!")
        }
    });

    $("#loan_period").blur(function(){
        if($("#loan_period").val()%1!=0||$("#loan_period").val()>52||$("#loan_period").val()<9){
            alert("Invalid Input!")
        }
    });*/

    $("#loan_amount").change(function(){
        if($("#loan_amount").val()<=2000){
            $("#loan_period").empty();
            var content="<option value=\"\">--Select--</option>\n" +
                "                                                <option value=\"9\">9</option>\n" +
                "                                                <option value=\"13\">13</option>\n" +
                "                                                <option value=\"17\">17</option>\n" +
                "                                                <option value=\"21\">21</option>\n" +
                "                                                <option value=\"25\">25</option>\n" +
                "                                                <option value=\"29\">29</option>\n" +
                "                                                <option value=\"33\">33</option>\n" +
                "                                                <option value=\"37\">37</option>\n" +
                "                                                <option value=\"41\">41</option>\n" +
                "                                                <option value=\"45\">45</option>\n" +
                "                                                <option value=\"49\">49</option>\n" +
                "                                                <option value=\"52\">52</option>"
            $("#loan_period").append(content);
        }

        else{
            $("#loan_period").empty();
            var content=" <option value=\"\">--Select--</option>\n" +
                "                            <option value=\"10\">10</option>\n" +
                "                            <option value=\"14\">14</option>\n" +
                "                            <option value=\"18\">18</option>\n" +
                "                            <option value=\"22\">22</option>\n" +
                "                            <option value=\"26\">26</option>\n" +
                "                            <option value=\"30\">30</option>\n" +
                "                            <option value=\"34\">34</option>\n" +
                "                            <option value=\"38\">38</option>\n" +
                "                            <option value=\"42\">42</option>\n" +
                "                            <option value=\"46\">46</option>\n" +
                "                            <option value=\"50\">50</option>\n" +
                "                            <option value=\"54\">54</option>\n" +
                "                            <option value=\"58\">58</option>\n" +
                "                            <option value=\"62\">62</option>\n" +
                "                            <option value=\"66\">66</option>\n" +
                "                            <option value=\"70\">70</option>\n" +
                "                            <option value=\"74\">74</option>\n" +
                "                            <option value=\"76\">76</option>"
            $("#loan_period").append(content);
        }
    });

    $("#loan_period").change(function(){
        const period = $("#loan_period").val();
        const amount = $("#loan_amount").val();
        if(period && amount) {
            let principle = parseFloat(amount) + 400;
            let weeks = parseInt(period);
            let rate = 0.48/52.18;
            let totalFee = calculatePMT(principle, weeks, rate);

            $("#repayment").text('$' + toFixed(totalFee,2));
        }
    });

    const calculatePMT = (pv, n, r) => {
        // PMT = PV * r / (1 - (1 + r)^(-n))
        const pmt = pv * r / (1 - Math.pow(1 + r, -n));
        return pmt;
    };

    function toFixed(num, fixed) {
        fixed = fixed || 0;
        fixed = Math.pow(10, fixed);
        return Math.floor(num * fixed) / fixed;
    }



    $("#loan_type").change(function(){
        if($("#loan_type").val()==1){
            $("#MACC").css("display","block");
            $("#SACC").css("display","none");
            $("#loan_amount_MACC").attr("required","required")
            $("#loan_period_MACC").attr("required","required")
            $("#loan_amount").removeAttr("required");
            $("#loan_period").removeAttr("required");


        }
        if($("#loan_type").val()==0){
            $("#SACC").css("display","block");
            $("#MACC").css("display","none");
            $("#loan_amount").attr("required","required")
            $("#loan_period").attr("required","required")
            $("#loan_amount_MACC").removeAttr("required");
            $("#loan_period_MACC").removeAttr("required");
        }
    });
    var phone_msg = "Please Click Mobile Icon to get code";
    var phone_code = 0;

   $("#phone_check").click(function(){
        var objectModel = {};
        var   value = $("#mobile").val();
        var   type = $("#mobile").attr('id');
        const img = this;
        const loadingIcon = "data:image/svg+xml;base64,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";
        const phoneIcon = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADQAAAApCAMAAABN7vqcAAAAllBMVEUAAAD////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////AJcWoAAAAMXRSTlMAHmY8zJkECvz28CIWEtnq5MW2XjfgsIRaVUdAD+2/pqKRinp1Y03V0Z5yMrpsyX4o5S5RGAAAAbxJREFUSMeV1eluozAUhuEP2rKZNRD2JIQkZG075/5vbgyeETRUR+H9gyx4pGNLyBgzm4CeC68m2Habm/7c0WlY41k5hrZEgRY+1OJkefgtLSyGB72pdaXrOfJKLd5IgywO3Z/oy6+NvZDo9zS4Mdz1FtMKSpA5mkStPq+V6C4Hr6icolUEzY7VeLPUeNmmRpRiUnCAbpss8qwC32uMGRQjO4NFWH8jtjHJ1nELWKSmcTDp8oGEKhYl8tUugur+8PpdmojOJoOMbWR4zgFDiUMPwHX2EP6dQaUtcHW8/yb8A+BEJfg91egoVktlZIXGI5no0FfZFAqM8UhV2rQWWIKU0bAMdTb5GhiUzFEhjQsGnazrMyosOrvg0J7oavxAuUUXFwxSamdMUGzRuwfwCK1S/5BO9FWDQ6qMKDUU6k00GgbhQLQyBvQpjQkeTZUp0ZFoOzE8Qv91RW1v8TLq57rQzLBInZo6jyUIp+E0FiJkJMCi9GNeShqP/Pd5/gTx43XHbvw1XkR7cqhdiFz6xNFyl6E7JShJLEOGf9H9s/ES8iiHSqzWqcB453Ltgvntfts0YKubDT0XNCbm/QUcHDv0t/o+qAAAAABJRU5ErkJggg==";
        if(value == '') {
            swal.fire({
                icon: 'warning',
                title: 'mobile number is required',
            })
            return;
        }
        img.src = loadingIcon;

        objectModel[type] =value;
        $.ajax({
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            url:"/application/send_phone_code",
            type:"post",
            dataType:"json",
            data:objectModel,
            timeout:30000,
            success:function(data){

                phone_msg = data.msg;
                phone_code = data.state;

                swal.fire({
                    icon: 'warning',
                    title: data.msg,
                })

                $("#veri_code").attr('readonly',false);
                img.src = phoneIcon;
            }
        });
        return false;

    });

    var current_page = 1;

    function showStep(offset) {
        current_page = current_page + offset;
        if(current_page > 4) current_page = 4;
        if(current_page < 1) current_page = 1;

        $('#step'+current_page).show().siblings('.step').hide();

        if(current_page > 1) $('#prev_page').show();
        else $('#prev_page').hide();

        if(current_page < 4) $('#next_page').text('Next');
        else $('#next_page').text('Submit');

        //change progressbar
        let width = (current_page)/4*100 + '%';

        $('#progressbar').css({width:width});
        $('#progressbar').text(width);

        // animated top scrolling
        var pos = $('#progressbar').offset().top;
        $('body, html').animate({scrollTop: pos});
    }



    //next page and pre page
    $('#next_page').unbind('click').bind('click', function (e) {
        //validate form data
        if(current_page >= 1 && current_page <= 4) {
            var elements = $('#step'+current_page).find('input,textarea,select').filter('[required]:visible');

            for(let i=0; i < elements.length;i++) {
                if($(elements[i]).val() == '') {
                    $(elements[i]).focus();
                   /* swal.fire({
                        icon: 'warning',
                        title: 'Can Not Be Blank',
                    })*/
                    $(elements[i]).css('border-color', 'red')
                    return false;
                }

                //check if mobile check ok?
                if($(elements[i]).attr('id') === "mobile" && phone_code !== 1) {


                    $(elements[i]).focus();
                    return false;
                }

               /* if($(elements[i]).attr('id') === "veri_code" && verifyresult !== 1) {


                    $(elements[i]).focus();
                    return false;
                }*/



            }

            if(current_page === 2) {
                if($("#emp_status").val() === 'unemployed-government benefits'){
                    swal.fire({
                        icon: 'warning',
                        title: 'Thank you for your loan application. Unfortunately, based on the information you have provided, we are unable to assist you on this occasion. You are welcome to reapply if your circumstances change.',
                    })
                    $(this).focus();
                    return false;
                }
            }


            if(current_page === 3) {

                if(  parseInt($( "#pension" ).val())+ parseInt($( "#monthly_after_tax").val()) + (parseInt($("#another_job_income").val()) || 0)
                    < parseInt($("#mortgage_rent").val())+ parseInt($( "#travel_expense" ).val())+parseInt( $( "#insurance" ).val())+
                    parseInt($( "#home_utility_exp" ).val())+parseInt($( "#food_entertainment" ).val())+parseInt($( "#personal_exp").val()) +parseInt($("#loan_payment").val())){
                    if(!confirm( "Your income is less than expense, do you want to continue?")) return false;
                }

            }

            //page 4 other question radio
            if(current_page === 4) {
                if (!$("input[name='gambling']").is(':checked')) {
                    swal.fire({
                        icon: 'warning',
                        title: 'please answer all questions',
                    })
                    return false;
                }

                if (!$("input[name='repay_loan']").is(':checked')) {
                    swal.fire({
                        icon: 'warning',
                        title: 'please answer all questions',
                    })
                    return false;
                }

                if (!$("input[name='credit_defaults']").is(':checked')) {
                    swal.fire({
                        icon: 'warning',
                        title: 'please answer all questions',
                    })
                    return false;
                }

                if (!$("input[name='given_info']").is(':checked')) {
                    swal.fire({
                        icon: 'warning',
                        title: 'please answer all questions',
                    })
                    return false;
                }

                if (!$("input[name='non_essential_spending']").is(':checked')) {
                    swal.fire({
                        icon: 'warning',
                        title: 'please answer all questions',
                    })
                    return false;
                }

               /* if (!$("input[name='loan_interest']").is(':checked')) {
                    swal.fire({
                        icon: 'warning',
                        title: 'please answer all questions',
                    })
                    return false;
                }*/

                if (!$("input[name='undischarged_bankrupt']").is(':checked')) {
                    swal.fire({
                        icon: 'warning',
                        title: 'please answer all questions',
                    })
                    return false;
                }

                if (!$("input[name='credit_guide']").is(':checked') || !$("input[name='credit_guide1']").is(':checked') || !$("input[name='credit_guide2']").is(':checked') || !$("input[name='credit_guide3']").is(':checked')) {
                    swal.fire({
                        icon: 'warning',
                        title: 'please agree our policy',
                    });
                    return false;
                }
            }
        }

        if(current_page < 4) {
            showStep(1);
            return false;
        }
        $( "#application" ).submit();

    });

    $('#prev_page').unbind('click').bind('click', function (e) {
        showStep(-1);
    });




    $("#loan_yes").change(function () {
        $("#loan_num_div").css("display","block");


    })

    $("#loan_no").change(function () {
        $("#loan_num_div").css("display","none");
    })




    // keep two digital, without round
    function toFixed(num, fixed) {
        fixed = fixed || 0;
        fixed = Math.pow(10, fixed);
        return Math.floor(num * fixed) / fixed;
    }


    //hover not show a title
    $('a').on('mouseenter', function(e){
        e.preventDefault();
        $(this).removeAttr('title');
    });


})
